import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Typography, Button, Box, LinearProgress } from "@mui/material";
import { Web, Storage, TrendingUp } from "@mui/icons-material";

export default function QuickActionsCard() {
  const navigate = useNavigate();
  const { usage } = useSelector((state) => state.plan);

  const storageUsed = usage?.storageUsedGB || 0;
  const storageLimit = usage?.storageLimitGB || 0;
  const storagePercent = usage?.storagePercentage || 0;

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 2.5,
        flexGrow: 1,
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2.5 }}>
        Quick Actions
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Button
          variant="contained"
          fullWidth
          onClick={() => navigate("/dashboard/sites")}
          disableElevation
          sx={{
            justifyContent: "flex-start",
            px: 2,
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 2,
          }}
        >
          <Web sx={{ mr: 1 }} />
          Create New Site
        </Button>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => navigate("/dashboard/backups")}
          sx={{
            justifyContent: "flex-start",
            px: 2,
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 2,
          }}
        >
          <Storage sx={{ mr: 1 }} />
          Manage Backups
        </Button>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => navigate("/dashboard/analytics")}
          sx={{
            justifyContent: "flex-start",
            px: 2,
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 2,
          }}
        >
          <TrendingUp sx={{ mr: 1 }} />
          View Analytics
        </Button>
      </Box>

      {storageLimit > 0 && (
        <Box sx={{ mt: 4 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
            Storage Usage
          </Typography>
          <Box sx={{ mb: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 1,
              }}
            >
              <Typography variant="body2" color="text.secondary">
                {storageUsed} GB of {storageLimit} GB
              </Typography>
              <Typography variant="body2" fontWeight={600}>
                {Math.round(storagePercent)}%
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={Math.min(storagePercent, 100)}
              color={
                storagePercent >= 90
                  ? "error"
                  : storagePercent >= 70
                    ? "warning"
                    : "primary"
              }
              sx={{ height: 8, borderRadius: 4 }}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
